export default __webpack_public_path__ + "static/media/math-matrices-blue.cb2bc8aa.svg";